import { render, staticRenderFns } from "./ReferralModal.vue?vue&type=template&id=31cd36e6&scoped=true"
import script from "./ReferralModal.vue?vue&type=script&lang=js"
export * from "./ReferralModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralModal.vue?vue&type=style&index=0&id=31cd36e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cd36e6",
  null
  
)

export default component.exports